import { Id, PaginatedCollection, PermissionRule } from "PFTypes";

export enum ClosureReasonKey {
  FilledExternally = "filled_externally",
  FilledWithNamedResource = "filled_with_named_resource"
}

export type Vacancy = {
  id: number;
  activityId: number;
  profileIds: Id[];
  closureReason: ClosureReasonKey;
  closureDetails: string;
  state: string;
  createdAt: string;
  updatedAt: string;
};

type RestrictedPolicy = PermissionRule.FillNamedResource;

export type ClosureReason = {
  key: ClosureReasonKey;
  label: string;
  hidden: boolean;
  massClose?: boolean;
  restrictedPolicies?: RestrictedPolicy[];
};

type VacanciesMetaCustomFields = {
  availableClosureReasons: ClosureReason[];
  totalFilled: number;
  totalOpened: number;
};

export type VacanciesCollection = PaginatedCollection<Vacancy[], VacanciesMetaCustomFields>;
